import { Code, Text } from '@mantine/core';
import * as Sentry from '@sentry/react';

interface GraphqlNoDataProps {
  data: unknown;
}

function GraphqlNoData({ data }: GraphqlNoDataProps) {
  Sentry.captureException(Error('Incorrect or No GraphQL data!'), { extra: { data } });
  return (
    <div>
      <Text>Incorrect or Missing GraphQL data!</Text>
      <Code block>
        DATA:{'\n'}
        {JSON.stringify(data, null, 2)}
      </Code>
    </div>
  );
}

export default GraphqlNoData;
